export default "__VITE_ASSET__L0$LEAet5b27A8y$$nPHHw__";